import type { TImportDataDictionary } from "components/ImportData/type";
import { getJsonOrFalse } from "helpers/utils";

import type { TFileData } from ".";

export { suggestColumnMapping as suggestBulkUpdateMapping } from "components/ImportData/suggestColumnMapping";

export const BULK_UPDATE_MAPPING_STORAGE_KEY = "preferenceBulkUpdateMapping";

const getRawKey = (formattedKey: string) => formattedKey.replace(/^_/, "");

export const getSavedBulkUpdateMapping = (element: TImportDataDictionary): Record<string, string> | undefined => {
    const savedMappings = getJsonOrFalse(localStorage.getItem(BULK_UPDATE_MAPPING_STORAGE_KEY) ?? "{}");
    if (!savedMappings || typeof savedMappings !== "object") return;

    const elementMapping = savedMappings[element];
    if (!elementMapping || typeof elementMapping !== "object") return;

    return elementMapping;
};

export const saveBulkUpdateMapping = (element: TImportDataDictionary, selectedValues: Record<string, string>) => {
    const savedMappings = getJsonOrFalse(localStorage.getItem(BULK_UPDATE_MAPPING_STORAGE_KEY) ?? "{}") || {};
    savedMappings[element] = selectedValues;
    localStorage.setItem(BULK_UPDATE_MAPPING_STORAGE_KEY, JSON.stringify(savedMappings));
};

export const applyBulkUpdateMappingToLoadedData = (
    loadedData: TFileData,
    fileTitles: string[],
    selectedValues: Record<string, string>,
    repeatedKeys: string[] = [],
): TFileData => {
    return loadedData.map((row) => {
        const mappedRow: Record<string, unknown> = {};

        fileTitles.forEach((fileColumn) => {
            mappedRow[fileColumn] = row[fileColumn];
        });

        fileTitles.forEach((fileColumn) => {
            const crealoKey = selectedValues[fileColumn];
            if (!crealoKey || crealoKey === "Ignore") return;

            const value = row[fileColumn] ?? "";

            if (crealoKey !== "_id" && repeatedKeys.includes(getRawKey(crealoKey))) {
                const existingValue = mappedRow[crealoKey];
                // The CSV parser already groups repeated headers into an array; flatten so it isn't nested.
                mappedRow[crealoKey] = existingValue ? [existingValue, value].flat() : [value].flat();
            } else {
                mappedRow[crealoKey] = value;
            }
        });

        return mappedRow;
    });
};

export const isBulkUpdateMappingInitial = (fileTitles: string[], selectedValues: Record<string, string>) => {
    return fileTitles.every((fileColumn) => !selectedValues[fileColumn] || selectedValues[fileColumn] === "Ignore");
};
